export default __webpack_public_path__ + "static/media/ic-location-pointer-primary-light.c64f134d.svg";